import { Routes, Route } from "react-router-dom";

import { PagesLogin } from "../Pages/Login";


import ProtectedRoute from "../Context/ProtectedRoute";
import LayoutSistema from "../Layouts/LayoutSistema";
/* general */
import { PagesDashboard } from "../Pages/Dashboard";
import { PaginaPerfil } from "../Pages/Perfil";
import { PaginaCentrosClinicos } from "../Pages/CentrosClinicos";
import { PaginaEquipoClinico } from "../Pages/EquipoClinico";
import { PaginaGestionUsuarios } from "../Pages/GestionUsuarios";
import { Previsiones } from "../Pages/Previsiones";
/* CBO */
import { PaginaFlujoIngreso } from "../Pages/CBO/FlujoIngreso";
import { PaginaIngresoPaciente } from "../Pages/CBO/IngresoPaciente";
import { PaginaReporteSAP } from "../Pages/CBO/ReporteSAP";
import { PaginaCobroyDevengo } from "../Pages/CBO/CobrosyDevengo";
import { PaginaPrestaciondeServicio } from "../Pages/CBO/PrestacionServicios";
import { EgresoCBO } from "../Pages/CBO/Egreso";
import { IngresosCBOPages } from "../Pages/CBO/IngresosCBO";
import BuscarPacienteIndex from "../Pages/BusquedaPacienteIndex";


/* RME */
import IncomesIndex from "../Pages/RME/Incomes/IncomesIndex";
import { EgresoRMEIndex } from "../Pages/RME/Egresos/EgresosIndex";
import { RemuneracionIndex } from "../Pages/RME/Remuneracion/RemuneracionIndex";
import { PaginaFlujoIngresoRME } from "../Pages/RME/FlujoCajayEstadoResultado/FlujoIngreso";
import { EstadoResultado } from "../Pages/RME/FlujoCajayEstadoResultado/EstadoResultado";
import { IndexPorveedor } from "../Pages/RME/Provedores/ProveedoresIndex";

/* INMOB */

import { IndexInmob } from "../Pages/INMOB/Egresos";

function AppRoutes() {


  return (
    <Routes>
      <Route path="/" element={<PagesLogin />} />
      {/*  esta ruta debe estar protegida */}

      <Route element={<ProtectedRoute><LayoutSistema /></ProtectedRoute>}>

        <Route path="/inicio" element={<PagesDashboard />} />
        <Route path="/perfil" element={<PaginaPerfil />} />
        <Route path="/Usuarios" element={<PaginaGestionUsuarios />} />
        <Route path="/centros/clinicos" element={<PaginaCentrosClinicos />} />
        <Route path="/Equipo/clinico" element={<PaginaEquipoClinico />} />
        <Route path="/previsiones" element={<Previsiones />} />
        <Route path="/paciente/:id" element={<BuscarPacienteIndex />} />

        {/* CBO */}
        <Route path="/CBO/flujo-ingresos" element={<PaginaFlujoIngreso />} />
        <Route path="/CBO/informe/ingresos" element={<PaginaIngresoPaciente />} />
        <Route path="/CBO/SAP" element={<PaginaReporteSAP />} />
        <Route path="/CBO/prestacion/servicio" element={<PaginaPrestaciondeServicio />} />
        <Route path="/CBO/cobros-devengos" element={<PaginaCobroyDevengo />} />
        <Route path="/CBO/egresos" element={<EgresoCBO />} />
        <Route path="/CBO/incomes" element={<IngresosCBOPages />} />

        {/* RME */}
        <Route path="/RME/incomes" element={<IncomesIndex />} />
        <Route path="/RME/egresos" element={<EgresoRMEIndex />} />
        <Route path="/RME/remuneracion" element={<RemuneracionIndex />} />
        <Route path="/RME/flujocaja" element={<PaginaFlujoIngresoRME />} />
        <Route path="/RME/estadoresultado" element={<EstadoResultado />} />
        <Route path="/RME/proveedores" element={<IndexPorveedor />} />

        {/* INMOB */}
        <Route path="/INMOB/inicio" element={<IndexInmob />} />

      </Route>

    </Routes>
  );
}

export default AppRoutes;
